import React from 'react'
import { UseFormReturn } from 'react-hook-form';
import TextEditor from '../../../FormEditors/TextEditor';
import { VirtualMedicine } from '../../../../apis/virtual-medicines/types';

interface VirtualMedicineSizeEditorProps {
  form: UseFormReturn<VirtualMedicine>;
}

const VirtualMedicineSizeEditor = ({ form }: VirtualMedicineSizeEditorProps) => {
  return <TextEditor label="Size" control={form.control} name="size" />;
};

export default VirtualMedicineSizeEditor;
